import { render, staticRenderFns } from "./rewritingLevelPopup.vue?vue&type=template&id=a9bf43cc&scoped=true&"
import script from "./rewritingLevelPopup.vue?vue&type=script&lang=ts&"
export * from "./rewritingLevelPopup.vue?vue&type=script&lang=ts&"
import style0 from "./rewritingLevelPopup.vue?vue&type=style&index=0&id=a9bf43cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bf43cc",
  null
  
)

export default component.exports